<template>
  <div @click.stop="click">
    <el-checkbox v-if="!disabled" v-model="check" @change="change"></el-checkbox>
    <el-checkbox v-else disabled v-model="check"></el-checkbox>
  </div>
</template>
<script>
import { Checkbox } from 'element-ui';
import Vue from 'vue';
Vue.use(Checkbox);
export default {
  data() {
    return {
      check: false,
      disabled: false
    };
  },
  props: ['item', 'selectList'],
  methods: {
    change(v) {
      const { item } = this;
      this.$emit('change', { item, ifCheck: v });
    },
    click() {}
  },
  watch: {
    item: {
      immediate: true,
      deep: true,
      handler() {
        const { item } = this;
        if (item.status == 1) {
          // 如果该消息已经读过不允许点击
          this.disabled = true;
        }
      }
    },
    selectList: {
      deep: true,
      handler() {
        const { selectList, item } = this;

        let r = selectList.filter(v => {
          if (v.id == item.id) {
            return v;
          }
        });

        if (r.length > 0) {
          this.check = r[0].ifCheck;
        }
      }
    }
  }
};
</script>
